import { Component } from "react";
import * as React from "react";
import CreateSiteForm, { CreateSiteFormUser, UserAccessLevel } from "../models/CreateSiteForm";
import {Icon, TextField} from "office-ui-fabric-react";
import {MegaMenuItemSelector, MegaMenuOption, MegaMenuOptions} from "./MegaMenuItemSelector";
import UserSelector from "./UserSelector";
import * as _ from "lodash";
import { UserOption } from "./UserSelectorBase";
import TeamTemplateSelector from "./TeamTemplateSelector";

export interface CreateSiteCardProps {
    tenantId: string;
    schoolCode: string;
    form: CreateSiteForm;
    megaMenuOptions: MegaMenuOptions;
    disabled: boolean;
}

export interface CreateSiteCardState {
    form: CreateSiteForm;
}

export default class CreateTeamSiteCard extends Component<CreateSiteCardProps, CreateSiteCardState>
{
    public static buildCardTitle(form: CreateSiteForm): JSX.Element {
        if (form.siteName) {
            return (
                <div className={"card__title"}>
                    <span>{form.siteName}</span>
                    <br>
                    </br>
                    <span className={"text-extra-detail"}>{_.capitalize(form.siteType)} site</span>
                </div>
            );
        }
        else {
            return (
                <div className={"card__title"}>
                    <span>New {_.capitalize(form.siteType)} Site</span>
                </div>
            );
        }
    }

    constructor(props: Readonly<CreateSiteCardProps>) {
        super(props);

        this.state = {
            form: props.form
        };
    }

    componentDidUpdate(prevProps: Readonly<CreateSiteCardProps>, prevState: Readonly<CreateSiteCardState>, snapshot?: any): void {
        if (this.props.form !== prevProps.form) {
            this.setState({ form: this.props.form });
        }
    }

    private setFormUsersForAccessLevel(userOptions: UserOption[], accessLevel: UserAccessLevel) {
        let usersNotThisLevel = this.state.form.users.filter(g => g.access !== accessLevel);

        let usersForThisLevel = userOptions.map((userOption: UserOption): CreateSiteFormUser => {
            return {
                userId: userOption.id,
                userDisplayName: userOption.displayName,
                userPrincipalName: userOption.userPrincipalName,
                access: accessLevel
            };
        });

        this.state.form.users = usersNotThisLevel.concat(usersForThisLevel);

        this.setState({
            form: this.state.form
        });
    }

    public componentDidMount() {
    }

    public render() {

        let selectedMegaMenuOption: MegaMenuOption | undefined = this.state.form.menuSiteUrl ? { listName: this.state.form.menuListName!, sitePathForList: this.state.form.siteName! } : undefined;
        
        return (
            <div className="create-site-card">

                <div className={"card__header"}>
                    <Icon iconName="TeamsLogo" className={"p-left-1rem"} />
                    {CreateTeamSiteCard.buildCardTitle(this.state.form)}
                    {this.props.children}
                </div>

                <div className={"card__content"}>
                    <div className={"create-site-card__row"}>

                        <TextField
                            className="flex-item--flex-1 m-right-1rem"
                            disabled={this.props.disabled}
                            label="Site Name"
                            value={this.state.form.siteName}
                            required
                            onChange={(siteName: any) => {
                                this.state.form.siteName = siteName.target.value;
                                this.setState({
                                    form: this.state.form
                                });
                            }
                            } />

                        <TeamTemplateSelector
                            className="m-right-1rem"
                            selectedTeamTemplate={this.state.form.teamTemplate || "standard"}
                            disabled={this.props.disabled} onChanged={(teamTemplate) =>
                        {
                            this.state.form.teamTemplate = teamTemplate;
                            this.setState({
                                form: this.state.form
                            });
                        }
                        }/>
                        
                        <MegaMenuItemSelector
                            megaMenuOptions={this.props.megaMenuOptions}
                            disabled={this.props.disabled}
                            selectedMegamenuOption={selectedMegaMenuOption}
                            onSelectionChanged={(megaMenuOption: MegaMenuOption) => {
                                this.state.form.menuListName = megaMenuOption.listName;
                                this.state.form.menuSiteUrl = megaMenuOption.sitePathForList;

                                this.setState({
                                    form: this.state.form
                                });
                            }}
                        />
                    </div>

                    <UserSelector
                        tenantId={this.props.tenantId}
                        className="m-top-05rem"
                        disabled={this.props.disabled}
                        multiSelect={true}
                        label={"Owners"}
                        selectedUsers={this.props.form.users.filter(u => u.access === "owner").map((u) => {
                            return { id: u.userId, displayName: u.userDisplayName, userPrincipalName: u.userPrincipalName };
                        })
                        }
                        onSelectionChanged={(selectedUsers: UserOption[]) => this.setFormUsersForAccessLevel(selectedUsers, "owner")} />

                    <UserSelector
                        tenantId={this.props.tenantId}
                        className="m-top-05rem"
                        disabled={this.props.disabled}
                        multiSelect={true}
                        label={"Members"}
                        selectedUsers={this.props.form.users.filter(u => u.access === "member").map((u) => {
                            return { id: u.userId, displayName: u.userDisplayName, userPrincipalName: u.userPrincipalName };
                        })
                        }
                        onSelectionChanged={(selectedUsers: UserOption[]) => this.setFormUsersForAccessLevel(selectedUsers, "member")} />
                </div>

            </div>
        );
    }
}